import * as React from "react";
import { useLink } from "@grandvisionhq/frk-routing";
import { useSelector, useDispatch, statusFailed, statusLoading } from "@grandvisionhq/state";
import { getAuth } from "../../selectors.js";
import ExpiredLinkView from "../ExpiredLinkView/ExpiredLink/ExpiredLinkView/ExpiredLinkView.js";
import { resetPassword } from "../../ResetPassword/ResetPassword/actions.js";
import { signup } from "../../CreateAccount/CreateAccount/actions.js";
const ExpiredLink = ({ targetAction }) => {
  const { resetPasswordCall, signupCall } = useSelector(getAuth);
  const { href: loginRoute } = useLink({ route: "auth.login" }) || {};
  const loginUrl = loginRoute || "#";
  const dispatch = useDispatch();
  const expiredLinkProps = React.useMemo(() => {
    if (targetAction === "forgotPassword") {
      return {
        onResend: (payload) => {
          dispatch(resetPassword(payload));
        },
        titleLabelKey: "account.resetPassword.submitEmailAddress.title",
        loginUrl,
        isLoading: statusLoading(resetPasswordCall),
        hasError: statusFailed(resetPasswordCall)
      };
    } else {
      return {
        onResend: (payload) => {
          dispatch(signup(payload));
        },
        titleLabelKey: "account.createAccount.title",
        loginUrl,
        isLoading: statusLoading(signupCall),
        hasError: statusFailed(signupCall)
      };
    }
  }, [
    targetAction,
    signupCall,
    resetPasswordCall,
    statusLoading,
    statusFailed,
    loginUrl,
    resetPassword,
    signup
  ]);
  return /* @__PURE__ */ React.createElement(ExpiredLinkView, { ...expiredLinkProps });
};
export {
  ExpiredLink as default
};
//# sourceMappingURL=ExpiredLink.js.map
